/* eslint-disable */

import moment from 'moment';
import jsPdf from 'jspdf';
import * as XLSX from 'xlsx';
import {
  getTransportCertificates
} from '../actions'

export const sortTransportCertificates = (transportCertificates, order, orderBy) => (dispatch) => {

  dispatch({ type: 'SORT_TRANSPORT_CERTIFICATES', payload: { transportCertificates, order, orderBy } });
};

export const changePageTransportCertificates = (page) => (dispatch) => {

  dispatch({ type: 'CHANGE_PAGE_TRANSPORT_CERTIFICATES', payload: { page } });
};

export const changeRowsPerPageTransportCertificates = (rowsPerPage) => (dispatch) => {

  dispatch({ type: 'CHANGE_ROWS_PER_PAGE_TRANSPORT_CERTIFICATES', payload: { rowsPerPage } });
};


// const handleErrors = (response) => {
//   if (!response.ok) {
//     throw Error(response.statusText);
//   }
//   return response;
// }



export const filterShTextChanged = (text) => (dispatch) => {
  dispatch({ type: 'TRANSPORT_CERTIFICATES_SHFILTER_CHANGED', payload: text });
};

export const filterSpTextChanged = (text) => (dispatch) => {
  dispatch({ type: 'TRANSPORT_CERTIFICATES_SPFILTER_CHANGED', payload: text });
};

export const filterDateTextChanged = (text) => (dispatch) => {
  dispatch({ type: 'TRANSPORT_CERTIFICATES_DATEFILTER_CHANGED', payload: text });
};

export const filterTextChanged = (text) => (dispatch) => {

  dispatch({ type: 'TRANSPORT_CERTIFICATES_FILTER_CHANGED', payload: text });
};

export const filterProductTextChanged = (text) => (dispatch) => {
  dispatch({ type: 'TRANSPORT_CERTIFICATES_PRODUCTFILTER_CHANGED', payload: text });
};

export const toggleFilter = () => (dispatch) => {
  dispatch({ type: 'TOGGLE_FILTER_TRANSPORT_CERTIFICATES' });
};

export const setCardsStartDate = (startDate) => (dispatch) => {
  dispatch({ type: 'SET_CARDS_STARTDATE', payload: startDate });
};

export const setCardsEndDate = (endDate) => (dispatch) => {
  dispatch({ type: 'SET_CARDS_ENDDATE', payload: endDate });
};

export const setStartDate = (startDate) => (dispatch) => {
  dispatch({ type: 'SET_STARTDATE_TRANSPORT_CERTIFICATES', payload: startDate });
};
export const setEndDate = (endDate) => (dispatch) => {
  dispatch({ type: 'SET_ENDDATE_TRANSPORT_CERTIFICATES', payload: endDate });
};

export const toggleStartDateDialog = () => (dispatch) => {
  dispatch({ type: 'TOGGLE_STARTDATE_TRANSPORT_CERTIFICATES' });
};
export const toggleEndDateDialog = () => (dispatch) => {
  dispatch({ type: 'TOGGLE_ENDDATE_TRANSPORT_CERTIFICATES' });
};

export const fetchSmireDataTransportCertificates = async (sites, start, end) => {

  /*let url = 'https://weechain.guru-trading.com/api/smire/sites_time_series?sites=' + sites +
            '&start='+ start +'&end=' + end + '&freq=D';

	let username = 'admin';
	let password = 'weechain1234';*/

  let url = 'https://smire.bluesafire.io/api/daily_data_on_period?site=' + sites + '&specific_timezone=Europe%2FParis&start=' + start + '&end=' + end;

  let username = 'weechain.technical@gmail.com';
  let password = 'oEltPRRZDErt6VtvJz7U1g==';

  let headers = new Headers();
  headers.set('Authorization', 'Basic ' + Buffer.from(username + ":" + password).toString('base64'));


  const response = await fetch(url, { method: 'GET', headers: headers });

  const json = await response.json();
  return json;
}

export const fetchDeliveryData = async () => {

  //let url = './assets/sheets/ENGIE_-_Customer_Portal.xlsx';

  //let url = './assets/sheets/ENGIE_-_Customer_Portal_9Juillet.xlsx';
  let url = './assets/sheets/ENGIE_-_Customer_Portal_3SeptembreClean.xlsx';

  const response = await fetch(url);
  const responseArrayBuffer = await response.arrayBuffer();

  var data = new Uint8Array(responseArrayBuffer);

  var workbook = XLSX.read(data, { type: "array" });


  let deliverySheet = workbook.Sheets[workbook.SheetNames[0]];

  let deliveriesInit = XLSX.utils.sheet_to_json(deliverySheet);
  let deliveries = deliveriesInit.filter((delivery, index) => {
    return (index > 0 || parseFloat(delivery[" Volume "].replace(',', '').replace(' ', '').replace('-', '0') !== 0));
  })

  //let deliveries = require('../assets/json/deliveries.json');


  //let deliveries = require('../assets/json/deliveries.json');
  let mappedDeliveries = deliveries.map((delivery, index) => {

    return {
      ...delivery,
      volume: parseFloat(delivery[" Volume "].replace(',', '').replace(' ', '').replace('-', '0')),
      id: delivery["Bon de livraison"],
      date: moment(delivery["Date de livraison"], 'MM/DD/YYYY').format('DD/MM/YYYY'),
      curstomerSiteId: delivery["__EMPTY"] ? delivery["__EMPTY"] : '',
      curstomerSiteName: delivery["__EMPTY_1"] ? delivery["__EMPTY_1"] : '',
      curstomerId: delivery["__EMPTY_2"] ? delivery["__EMPTY_2"] : '',
      curstomerName: delivery["__EMPTY_3"] ? delivery["__EMPTY_3"] : '',
    };
  });
  /*
  let co2TransportSheet = workbook.Sheets[workbook.SheetNames[1]];
  let co2Transport = XLSX.utils.sheet_to_json(co2TransportSheet);
  */
  let co2Transport = require('../assets/json/co2transport.json');

  //get the data that triggers 0 for cO2 :
  /*
  let co2EmissionsKOCount = 0;
  const co2EmissionsKOSitesIds = [];
  const co2EmissionsKOSitesNames = [];
  */


  let mappedDeliveriesWithCo2 = mappedDeliveries.map((delivery, index) => {

    let currentDeliveryCo2 = co2Transport.find(co2Delivery => {
      return co2Delivery["__EMPTY"] === delivery["__EMPTY"]
    });

    let volume = parseFloat(delivery[" Volume "].replace(',', '').replace(' ', '').replace('-', '0'));
    let co2MT = 0;
    if (currentDeliveryCo2 && currentDeliveryCo2["à utiliser dans le calcul"]) {
      co2MT = parseFloat(currentDeliveryCo2["à utiliser dans le calcul"].replace(',', '').replace(' ', '').replace('-', '0'))
    }
    //let co2MT = parseFloat(currentDeliveryCo2["à utiliser dans le calcul"].replace(',','').replace(' ','').replace('-','0'))
    let co2Emissions = co2MT * volume / 1000;
    /*if(co2Emissions === 0) {
      

      co2EmissionsKOCount++;
      co2EmissionsKOSitesIds.push(delivery.curstomerSiteId)
      co2EmissionsKOSitesNames.push(delivery.curstomerSiteName)
      
      console.log('co2EmissionsKO', delivery);
      

    }*/

    return { ...delivery, co2Emissions, volume };
  }).filter(delivery => {
    return delivery.co2Emissions > 0
  });

  /*
  const co2EmissionsKOSitesIdsUnique = co2EmissionsKOSitesIds.filter(function(item, pos) {
    return co2EmissionsKOSitesIds.indexOf(item) == pos;
  });


  const co2EmissionsKOSitesNamesUnique = co2EmissionsKOSitesNames.filter(function(item, pos) {
    return co2EmissionsKOSitesNames.indexOf(item) == pos;
  });
  console.log('co2EmissionsKOCount = '+co2EmissionsKOCount);
  console.log('co2EmissionsKOSitesIdsUnique = ', co2EmissionsKOSitesIdsUnique);
  console.log('co2EmissionsKOSitesNamesUnique = ', co2EmissionsKOSitesNamesUnique);
  */



  let currentCustomerDeliveriesWithCo2 = mappedDeliveriesWithCo2.filter((delivery, index) => {
    if (localStorage.getItem('username') === 'sanofi') {
      const deliveryCustomerName = delivery.curstomerName.toLowerCase();
      return deliveryCustomerName.includes('sanofi');
      //return delivery.curstomerId === "108982"
    }
    if (localStorage.getItem('username') === 'demo_ap') {
      const deliveryCustomerName = delivery.curstomerName.toLowerCase();
      return deliveryCustomerName.includes('My Green Company');
      //return delivery.curstomerId === "108982"
    }
    if (localStorage.getItem('username') === 'airproducts') {
      const deliveryCustomerName = delivery.curstomerName.toLowerCase();
      return deliveryCustomerName.includes('My Green Company') ? false : true;
      //return delivery.curstomerId === "108982"
    }
    return true;
  })

  return { mappedDeliveries: mappedDeliveriesWithCo2, currentCustomerDeliveries: currentCustomerDeliveriesWithCo2 };
}

export const getTransportCertificatesStart = () => async (dispatch) => {


  dispatch({ type: 'GET_TRANSPORT_CERTIFICATES_START' });/*
  const certificates = [];

  const startDate = "2018-01-01";
  const endDate = moment().format("YYYY-MM-DD");
  const startDateCo2 = "01/01/2018";
  const endDateCo2 = moment().format("DD/MM/YYYY");
  console.log('Starting lida at '+moment().format('HH:mm:ss'))
  const energyData = await fetchSmireDataTransportCertificates("plt_mareges,eget,fontanelles,lida", startDate, endDate);
  console.log('Finished lida at '+moment().format('HH:mm:ss'))
  console.log('Starting lida_rte at '+moment().format('HH:mm:ss'))
  const energyDataRTE = await fetchSmireDataTransportCertificates("plt_mareges,eget,fontanelles,lida_rte", startDate, endDate);
  console.log('Finished lida at '+moment().format('HH:mm:ss'))
  console.log('Starting co2Data at '+moment().format('HH:mm:ss'))
  //const co2Data = await getCo2Data(startDateCo2, endDateCo2);
  const co2Data = await getCo2DataWithoutDispatch();
  console.log('Finished co2Data at '+moment().format('HH:mm:ss'))

  
  

  const result = await fetchDeliveryData();

  const currentCustomerDeliveriesWithSavedCo2 = result.currentCustomerDeliveries.map((delivery, co2Index) => {
    const co2ForDay = co2Data.find(data => {
      
      return moment(delivery.date, 'DD/MM/YYYY').format('YYYY-MM-DD') === data.date;
    });

    
    const energyDates = energyData.index;
    const energyArray = energyData.data;


    const energyDatesRTE = energyDataRTE.index;
    const energyArrayRTE = energyDataRTE.data;

    const checkLidaRteDate = (moment(delivery.date, 'DD/MM/YYYY').toDate() < moment('02/05/2018', 'DD/MM/YYYY').toDate());

    let energyDataForDayIndex = checkLidaRteDate ? energyDates.findIndex(date => {
      return moment(delivery.date, 'DD/MM/YYYY').format('YYYY-MM-DD') === moment(date).format('YYYY-MM-DD');
    })
    :
    energyDatesRTE.findIndex(date => {
      return moment(delivery.date, 'DD/MM/YYYY').format('YYYY-MM-DD') === moment(date).format('YYYY-MM-DD');
    })

    let energyForDay = checkLidaRteDate ? energyArray[energyDataForDayIndex] : energyArrayRTE[energyDataForDayIndex];


    let matchingProductionMareges = 0;
    let realProductionMareges = parseInt(energyForDay[0], 10);
    let matchingProductionEget = 0;
    let realProductionEget = parseInt(energyForDay[1], 10);
    let matchingProductionFontanelles = 0;
    let realProductionFontanelles = parseInt(energyForDay[2], 10);
    let residualConsumption = 0;
    let realConsumption = parseInt(energyForDay[3]*57/100, 10);

    if( realProductionFontanelles < realConsumption) {
      residualConsumption = realConsumption - realProductionFontanelles;
      matchingProductionFontanelles = realProductionFontanelles;

      if( realProductionEget < residualConsumption) {
        residualConsumption = residualConsumption - realProductionEget;
        matchingProductionEget = realProductionEget;

        if( realProductionMareges < residualConsumption) {
          residualConsumption = residualConsumption - realProductionMareges;
          matchingProductionMareges = realProductionMareges;
          
        } else {
          matchingProductionMareges = residualConsumption;
          residualConsumption = 0;
          
        }

      } else {
        matchingProductionEget = residualConsumption;
        residualConsumption = 0;
        
      }

    } else {
      matchingProductionFontanelles = realConsumption;
      residualConsumption = 0;
    }

    let energyMixforDay = residualConsumption;
    let energyMatchedForDay = matchingProductionEget + matchingProductionFontanelles + matchingProductionMareges;

    const deliveriesForDay = result.mappedDeliveries.filter(d => {
      return delivery.date === d.date;
    })

    let totalDeliveryVolumeForDay = 0;
    for (var i = 0; i < deliveriesForDay.length; i++) {
      totalDeliveryVolumeForDay += parseFloat(deliveriesForDay[i][" Volume "].replace(',','').replace(' ','').replace('-','0'));
    }
    const volume = parseFloat(delivery[" Volume "].replace(',','').replace(' ','').replace('-','0'))
    const deliveryPercentageForDay = volume/totalDeliveryVolumeForDay;
    if(co2ForDay) {
      delivery.co2SavedGoo = parseInt(deliveryPercentageForDay * realConsumption * co2ForDay.CO2/1000, 10);
      delivery.co2SavedTemp = parseInt(deliveryPercentageForDay * energyMatchedForDay * co2ForDay.CO2/1000, 10);
      delivery.co2EmissionsProd = parseInt(deliveryPercentageForDay * energyMixforDay * co2ForDay.CO2/1000, 10);
      delivery.co2EmissionsTot = delivery.co2EmissionsProd + delivery.co2Emissions;
    }
    else {
      //40g of C02 for 1kWh
      console.log('co2ForDayKo for date : '+delivery.date);
      delivery.co2SavedGoo = parseInt(deliveryPercentageForDay * realConsumption * 40/1000, 10);
      delivery.co2SavedTemp = parseInt(deliveryPercentageForDay * energyMatchedForDay * 40/1000, 10);
      delivery.co2EmissionsProd = parseInt(deliveryPercentageForDay * energyMixforDay * 40/1000, 10);
      delivery.co2EmissionsTot = delivery.co2EmissionsProd + delivery.co2Emissions;
    }

    return delivery;
  });

  console.log(JSON.stringify(currentCustomerDeliveriesWithSavedCo2, null, 4));
  */
  const transportCertificates = await getTransportCertificates();

  let currentCustomerDeliveriesWithCo2 = transportCertificates.data.filter((delivery, index) => {
    if (localStorage.getItem('username') === 'sanofi') {
      const deliveryCustomerName = delivery.curstomerName.toLowerCase();
      return deliveryCustomerName.includes('sanofi');
    }
    if (localStorage.getItem('username') === 'demo_ap') {
      const deliveryCustomerName = delivery.curstomerName.toLowerCase();
      return deliveryCustomerName.includes('my green company');
    }
    if (localStorage.getItem('username') === 'airproducts') {
      const deliveryCustomerName = delivery.curstomerName.toLowerCase();
      return deliveryCustomerName.includes('my green company') ? false : true;
      //return delivery.curstomerId === "108982"
    }
    return true;
  })


  let avoidedCo2YTD = 0;
  currentCustomerDeliveriesWithCo2.map(delivery => {
    avoidedCo2YTD += delivery.co2SavedTemp;
  })


  getTransportCertificatesSuccess(currentCustomerDeliveriesWithCo2, dispatch);
}

export const getTransportCertificatesSuccess = (certificates, dispatch) => {

  dispatch({ type: 'GET_TRANSPORT_CERTIFICATES_SUCCESS', payload: certificates });
};

export const getTransportCertificatesFail = (error, dispatch) => {

  dispatch({ type: 'GET_TRANSPORT_CERTIFICATES_FAIL' });
};

export const generateTransportCertificatePdf = (delivery) => async (dispatch) => {

  let customerName = '';
  if (localStorage.getItem('username') === 'sanofi') {
    customerName = 'Sanofi';
  }
  if (localStorage.getItem('username') === 'demo_ap') {
    customerName = 'My Green Company';
  }

  const topOffset = 4;
  const leftOffset = 15;

  const certificateIcon = new Image();
  certificateIcon.src = "./assets/images/certificate.png";

  const pdfDoc =
    new jsPdf({
      orientation: "landscape",
      unit: "cm",
      format: "a4",
    });
  //pdfDoc.addFont('ComicSansMS', 'Comic Sans', 'normal');
  //pdfDoc.setFont('Comic Sans');

  /*
  <TableCell numeric>{transportCertificate['Bon de livraison']}</TableCell>
  <TableCell>{transportCertificate.date}</TableCell>
  <TableCell>{transportCertificate.Produit}</TableCell>
  <TableCell numeric>{parseInt(transportCertificate.co2SavedTemp, 10).toLocaleString()}</TableCell>
  <TableCell numeric>{parseInt(transportCertificate.co2EmissionsTot, 10).toLocaleString()}</TableCell>
  <TableCell>{transportCertificate['__EMPTY_1']}</TableCell>
  <TableCell>{transportCertificate.curstomerSiteId}</TableCell>
  <TableCell>{transportCertificate['__EMPTY_3']}</TableCell>
  <TableCell>{transportCertificate.curstomerId}</TableCell>
  */

  pdfDoc.setFontSize(12);
  pdfDoc.setDrawColor(0, 174, 239);
  pdfDoc.setFillColor(255, 255, 255);
  pdfDoc.rect(0, 0, 29.7, 21, 'FD');
  pdfDoc.rect(0.1, 0.1, 29.5, 20.8, 'FD');

  pdfDoc.setTextColor(0, 174, 239);
  pdfDoc.setFontType("bold");
  pdfDoc.text(
    "Green Energy Certificate",
    leftOffset,
    topOffset,
    "center",
  );
  pdfDoc.setTextColor(193, 197, 201);
  pdfDoc.setFontType("normal");
  pdfDoc.text(
    "For the amount of",
    leftOffset,
    topOffset + 2,
    "center",
  );
  pdfDoc.setTextColor(68, 88, 108);
  pdfDoc.setFontType("bold");
  pdfDoc.text(
    parseInt(delivery.co2SavedTemp, 10).toLocaleString() +
    " kg of CO2 saved",
    leftOffset,
    topOffset + 3,
    "center",
  );
  pdfDoc.setTextColor(193, 197, 201);
  pdfDoc.setFontType("normal");

  pdfDoc.text(
    "For the delivery",
    leftOffset,
    topOffset + 4,
    "center",
  );

  pdfDoc.setTextColor(68, 88, 108);
  pdfDoc.setFontType("bold");
  pdfDoc.text(
    delivery["Bon de livraison"],
    leftOffset,
    topOffset + 5,
    "center",
  );
  pdfDoc.setTextColor(193, 197, 201);
  pdfDoc.setFontType("normal");
  pdfDoc.text(
    "On the Date",
    leftOffset,
    topOffset + 7,
    "center",
  );
  pdfDoc.setTextColor(68, 88, 108);
  pdfDoc.setFontType("bold");
  pdfDoc.text(
    delivery.date,
    //moment.unix(delivery.date).format('YYYY-MM-DD HH:mm'),
    leftOffset,
    topOffset + 8,
    "center",
  );
  pdfDoc.setTextColor(193, 197, 201);
  pdfDoc.setFontType("normal");
  pdfDoc.text(
    "Used for the exclusive and sole account of",
    leftOffset,
    topOffset + 9,
    "center",
  );
  pdfDoc.setTextColor(68, 88, 108);
  pdfDoc.setFontType("bold");
  pdfDoc.text(
    "Air Products & " + customerName,
    leftOffset,
    topOffset + 10,
    "center",
  );

  pdfDoc.setFontSize(10);
  pdfDoc.setTextColor(200, 200, 200);
  pdfDoc.text(
    [
      "This information is publicly and unalterably available in the Tobalaba Blockchain,",
      "and can be visible here https://tobalaba-explorer.energyweb.org/tx/0x63fb63ee90aa3b5cbc8cb8288bc763d35599ff94cd57c83082dc974509e8c50b"
    ],
    leftOffset,
    topOffset + 14,
    "center",
  );

  const myImage = new Image();
  myImage.src = "./assets/images/engie_logo_bleu.png";
  myImage.onload = function () {
    pdfDoc.addImage(myImage, 'png', 5, 3.2, 2, 1);
    pdfDoc.save("delivery_certificate.pdf");

    dispatch({ type: 'CERTIFICATE_SAVED' });
  };
}

/* 
const splitArray = (array) => {
  let returnArray = [];

  //this condition is too light
  if (array[0] == 0 && array[1] == 0) {
    returnArray.push(0);
    return returnArray;
  }
  else if (array[0] != 0) {
    returnArray.push(array[0]);
    let i;
    for (i = 1; i < array.length; i++) {
      if (array[i] != 0) {
        returnArray.push(array[i]);
      }
      else {
        return returnArray;
      }
    }
  }
  else {
    returnArray.push(array[0]);
    let i;
    for (i = 1; i < array.length; i++) {
      if (parseInt(array[i]) != 0) {
        returnArray.push(array[i]);
      }
      else {
        return returnArray;
      }
    }
  }
} */



// WEBPACK FOOTER //
// ./src/actions/TransportCertificatesActions.js